export default () => {

    let logo = document.getElementById('headerLogo');
    let doodle = document.getElementById('headerDoodle');

    setTimeout(() => {
        logo.classList.add('opacity-0');
        setTimeout(() => {
            logo.classList.add('hidden');
            doodle.classList.remove('opacity-0');
        }, 600)
    }, 5000)
}